import type { ClientConfig } from '@workspace/public-utils'

const starConfig: ClientConfig = {
  brandName: '스타로또',
  brandNameEn: 'STAR',
  logoIconText: 'S',
  logoIconColor: '#2563EB',
  defaultSiteName: '스타로또',
  seoTitleSuffix: '공식 로또 번호 생성 서비스',
  tagline: '대한민국 1등 온라인 복권 플랫폼',
  subTagline: '당신의 꿈을 현실로 만들어주는 신뢰할 수 있는 복권 서비스',
  copyrightFallback: '스타로또(Star Lottery)',
  ctaJoinText: '지금 바로 스타로또에 가입하고 첫 복권을 구매해보세요',
  whyChooseUs: '왜 스타로또를 선택해야 할까요?',
  statsSubtitle: '스타로또와 함께한 놀라운 성과들',
  joinNowCta: '지금 바로 스타로또와 함께하세요!',
  smartSystemCta: '스타로또의 스마트 번호 생성 시스템으로 다음 회차에 도전하세요',
  registerWelcome: 'STAR 스타로또와 함께하세요',
}

export default starConfig
